import { render, staticRenderFns } from "./LomInformation.vue?vue&type=template&id=63093231&scoped=true"
import script from "./LomInformation.vue?vue&type=script&lang=js"
export * from "./LomInformation.vue?vue&type=script&lang=js"
import style0 from "./LomInformation.vue?vue&type=style&index=0&id=63093231&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63093231",
  null
  
)

export default component.exports